enum MailboxType {
    /**
     * This is the primary mailbox associated with the account
     */
    UserMailbox,

    /**
     * This type represents any Groups that the given user account is part of
     */
    GroupMailbox,

    TeamsMailbox,

    /**
     * Mailbox Type to be used for Public folders scenarios.
     * Public folders can be added by right clicking the folders node in left nav in mail module.
     */
    PublicMailbox,
}

export default MailboxType;
